import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getMasterExpenseDataQuery = () => {
  return axios.get(apiurl?.getexpenseMaster);
};

const getMasterExpenseData = () => {
  return useQuery('getMasterExpenseData', getMasterExpenseDataQuery, { staleTime: Infinity });
};

export default getMasterExpenseData;
